<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        Admin
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">management</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Admin</a>
        </li>
      </ul>
    </div>
    <b-tabs
      active-nav-item-class="font-weight-bold text-uppercase text-danger">
      <b-tab title="Information">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              Admin Info
            </div>
            <div class="mb7">
              <span class="pull-right" v-if="!add && model.created_at">Joined_at  : {{model.created_at | datetime}}</span>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_use">
                Allow login
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_alive" :disabled="lock">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
              <span v-if="model.is_del" class="text-danger ml-4 mt-1">Deleted user, Logging in is not possible even if you allow it.</span>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_group">
                Permissions
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <select class="form-control" v-if="!lock" label="text" v-model="model.permissions">
                <option v-for="item in codes.permissions_admin" :key="item">{{item}}</option>
              </select>
              <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.id">
              <label class="col-form-label" for="">
                Last_visit
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-10 col-md-12 d-flex align-self-center">
              {{model.last_visit | datetime}} @ {{model.last_addr}}
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username">
                Username(ID)
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-form-input type="text" v-if="lock" v-model="model.username" plaintext></b-form-input>
              <b-form-input v-else class="form-control" :disabled="!add || lock" type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_nickname">
                Nick Name
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-form-input type="text" v-if="lock" v-model="model.nickname" plaintext></b-form-input>
              <b-form-input v-else class="form-control" type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <!-- <password :badge="true" v-model="model.new_password" :strengthMeterOnly="false" :toggle="false" @score="showScore" @feedback="showFeedback" /> -->
          <b-row class="mb-2 mt-3" v-show="add || !lock">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_pass">
                {{add ? '' : 'New'}} Password
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-form-input class="form-control" type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
              <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
              <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
                Min Length : 10
              </b-badge>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.new_password">
              <label class="col-form-label" for="ph_pass2">
                Password Repeat
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12"  v-if="model.new_password">
              <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_group" v-b-tooltip.hover title="Enter a single IP or network range, etc) 192.168.0.100, 192.168.0.0/24 ">
                Allowed IP
              </label>
            </b-col>
            <b-col class="col-xl-10 col-md-12">
              <b-form-textarea class="form-control" ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea>
            </b-col>
          </b-row>
          <br>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title_sub">
              Region
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_country_group">
                Country
                <span class="text-danger ml-1">*</span>
              </label>
            </div>
            <b-col class="col-xl-4 col-md-12">
              <select class="form-control" @input="set_country" :disabled="lock" label="name" v-model="region.country">
                <option v-for="(item, index) in codes.country" :key="index" :value="item">{{ item.name }}</option>
              </select>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_language_group">
                language
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <select class="form-control" @input="set_language" :disabled="lock" label="name" v-model="region.language">
                <option v-for="(item, index) in codes.language" :key="index" :value="item">{{ item.name }}</option>
              </select>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_timezone_group">
                Timezone
                <span class="text-danger ml-1">*</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <select class="form-control"  @input="set_timezone" :disabled="lock" label="name" v-model="region.timezone">
                <option v-for="(item, index) in codes.timezone" :key="index" :value="item">{{ item.name }}</option>
              </select>
            </b-col>
          </b-row>
          <div class="mt-5">
            <template v-if="lock">
              <b-button size="sm" variant="warning" @click="edit" :disabled="model.is_del">
                {{ model.is_del ? 'Admin was deleted' : 'Edit'}}
              </b-button>
              <b-button size="sm" variant="danger" v-if="!model.is_del" @click="confirm = true" :disabled="model.is_del"> Remove </b-button>
              <b-button size="sm" class="btn btn-cancel" @click="send_password_reset_mail" v-if="model.id && !model.is_del" :disabled="model.is_del"> Send Password Reset Mail </b-button>
            </template>
            <template v-else>
              <b-button size="sm" class="btn btn-add" @click="save"> Save </b-button>
              <b-button size="sm" variant="secondary" @click="cancel"> Cancel </b-button>
            </template>
            <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
          </div>
        </b-card>
      </b-tab>
      <!-- 해당 관리자의 로그인 로그 정보 -->
      <b-tab title="Login Log" :disabled="!model.id" @click="() => this.$refs.login_list && this.$refs.login_list.refresh()">
        <log-Login-List v-if="model.id" :user="model" ref="_login_list"></log-Login-List>
      </b-tab>
       <!-- 해당 관리자의 액션 로그 정보 -->
      <b-tab title="Action Log" :disabled="!model.id" @click="() => this.$refs.action_list && this.$refs.action_list.refresh()">
        <log-Action-List v-if="model.id" :user="model" ref="_action_list"></log-Action-List>
      </b-tab>
    </b-tabs>
    <!-- 안내 모달 시작 -->
    <b-modal title="Deletion of information"  class="modal-danger" header-bg-variant="danger" v-model="confirm" @ok="remove" ok-variant="outline-danger" cancel-variant="outline-dark">
      Are you sure you want to delete this information?
    </b-modal>
    <!-- 안내 모달 끝 -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>